export default __webpack_public_path__ + "static/media/nantes5.364fa3b9.jpg";